 import React, { useId, useRef, useEffect, useState } from "react";
 import { Helmet } from "react-helmet-async";
 import { styled } from "@mui/material/styles";
 import {
   Typography,
   Card,
   Stack,
   Box,
   TextField,
   FormGroup,
   FormControlLabel,
   Checkbox,
   Button,
   ButtonBase,
   Popover, 
 } from "@mui/material";
 import { useAuth0 } from "@auth0/auth0-react";
 import SignUpCompleteIcon from "src/public/assets/illustrations/signupComplete.png";


 


 export default function Complete({}) {


      const auth0LoginUrl =
  "https://dev-4m53d4wv8p6pmod8.us.auth0.com/u/login";


    const handleSignIn = () => {
    window.location.href = auth0LoginUrl;
  };



    return (

 <>

       <Box
      sx={{
        display: "flex",
        flexDirection: "column",   // put the animation on top, text below
        alignItems: "center",      // horizontal centering
        justifyContent: "center",  // vertical centering (optional)
      }}
    >
      <Box
        sx={{
          width: 275,
          height: 275,
   
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
      
          gap:1,
          mb:-2
        }}
      >

        <img src={SignUpCompleteIcon} alt="" style={{  }} />

      </Box>

      {/* centred text */}
    <Typography
      sx={{
        fontFamily: "'Lato', sans-serif",
        fontWeight: 900,
        fontSize: 23,
        color: "#456579",
        letterSpacing: "-0.02em",
        textAlign: "center",

        lineHeight:'50px'
      }}
    >
     Your account has been successfully created
     
    </Typography>
    <Typography sx={{
        fontFamily: "'Lato', sans-serif",
        fontWeight: 500,  
        fontSize: 17,
        color: "#456579",
        letterSpacing: "-0.03em",
        textAlign: "center",

        width:'410px'

      
      }}
    >
You can log into your account right away. Be sure to verify your email so you can start sending notifications to your customers. 

    </Typography>
                <Button
                onClick={handleSignIn}
                  variant="contained"
                  sx={{
                    fontFamily: "'Lato', sans-serif",
                    mt: "30px",
                    height: "59px",
                    backgroundColor: "#FF9490",
                    width:'400px',
                    fontSize: 22,
                    fontWeight: 600,
                    color: "#fff",
                    textTransform: "none",
                    boxShadow: "6px 9px 19.1px rgba(255, 148, 144, 0.3)",
                    borderRadius: "11px",
                    "&:hover": {
                      backgroundColor: "#FF7A7A",
                      boxShadow: "6px 9px 19.1px rgba(255, 122, 122, 0.35)",
                    },
                    "&:active": {
                      backgroundColor: "#FF5F5F",
                      boxShadow: "6px 9px 19.1px rgba(255, 95, 95, 0.4)",
                    },
                    "&:focus": {
                      backgroundColor: "#FF9490",
                      boxShadow: "6px 9px 19.1px rgba(255, 148, 144, 0.5)",
                    },
                  }}
                >
                  Login
                </Button>
    </Box>
              </>


  );
}
